import format from "date-fns/format";

import { ADD_TO_BASKET_URL } from "../../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../../models/BasketItem";
import { BasketItem } from "../../../../../models/BasketItem";
import useFacility from "../../../../../../utils/hooks/useFacility";
import useApiRequest from "../../../../../../utils/hooks/useApiRequest";
import { useState } from "react";

export default function usePCN() {
  const facilityIds = useFacility();
  const { post } = useApiRequest();
  const addGuideToBasket = async (ids: number, qnt: number) => {
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    const { isError } = await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),    });
  };



  const addPCNGuide = async (basketList: BasketItem[]) => {
    let biletGrupowySzkolny: number = 0;
    // 0,30
    let biletOpiekunGrupyInt: number = 0;
 //0,48
    let osZNiepelnosprawnoscia: number = 0;
    /// 0,34
    let opiekunOsZNiepelnosprawnoscia: number = 0;
// 0,47


    basketList.map((item: BasketItem) => {

      if (item.assortIds === "0,30") {
        biletGrupowySzkolny = biletGrupowySzkolny + item.qnt;
      }
      if (item.assortIds === "0,+48") {
        biletOpiekunGrupyInt = biletOpiekunGrupyInt + item.qnt;
      }

      if (item.assortIds === "0,34") {
        osZNiepelnosprawnoscia = osZNiepelnosprawnoscia + item.qnt;
      }
      if (item.assortIds === "0,+47") {
        opiekunOsZNiepelnosprawnoscia = opiekunOsZNiepelnosprawnoscia + item.qnt;
      }

  
    });

    setTimeout(() => {
      if (biletGrupowySzkolny > 0 || biletOpiekunGrupyInt > 0) {
        const guide = Math.floor(biletGrupowySzkolny / 10);
        if (guide - biletOpiekunGrupyInt !== 0) {
          addGuideToBasket(48, guide - biletOpiekunGrupyInt);
        }
      }

      if (osZNiepelnosprawnoscia > 0 || opiekunOsZNiepelnosprawnoscia > 0) {
        const guide = Math.ceil(osZNiepelnosprawnoscia / 1);
        if (guide - opiekunOsZNiepelnosprawnoscia !== 0) {
          addGuideToBasket(47, guide - opiekunOsZNiepelnosprawnoscia);
        }
      }


    }, 100);
  };

  return {
    addPCNGuide,

  };
}